import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set) => ({
      session: null,
      isLoading: false,
      error: null,
      hasHydrated: false,
      setSession(session) {
        if (!session?.accessToken || !session?.user?.email) {
          console.error('setSession: estructura de sesión inválida', session);
          return;
        }

        set({ session });
      },
      clearSession() {
        set({ session: null });
      },
      setLoading(isLoading) {
        set({ isLoading });
      },
      setError(error) {
        set({ error });
      },
      logout() {
        set({ session: null });
      },
    }),
    {
      name: 'eva-op-session',
      storage: createJSONStorage(() => window.localStorage),
      partialize: (state) => ({
        session: state.session,
      }),
    }
  )
);

useAuthStore.persist.onFinishHydration(() => {
  useAuthStore.setState({ hasHydrated: true });
});

if (useAuthStore.persist.hasHydrated()) {
  useAuthStore.setState({ hasHydrated: true });
}
